import React from 'react';
import Header from './Header';
import "../styles/operationarea.css" ;
import Operationgrid from "./OperationArea"
import Vector from "../assets/svg/editIcon.svg";
import Delete from "../assets/svg/DeleteIcon.svg";
import "../styles/grid.css";
import Popup from './Popup';


const SalaryData = () => {
    return (
        <>
  

        <Operationgrid/>
     
        </>
     
    );
};


export default SalaryData;